import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rouletteAPI } from '../../services/api';

/**
 * Fetch the roulette configuration from the backend.
 * Returns: { parts: [{ id, value }, ...] }
 */
export const fetchRouletteConfig = createAsyncThunk(
  'roulette/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const res = await rouletteAPI.getConfig();
      return res.data; // { parts: [...] }
    } catch (err) {
      console.warn('[Roulette] Could not fetch config, using fallback.', err.message);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const rouletteSlice = createSlice({
  name: 'roulette',
  initialState: {
    parts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRouletteConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRouletteConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.parts = action.payload?.parts || [];
      })
      .addCase(fetchRouletteConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default rouletteSlice.reducer;
